<template>
  <div class="SectionExplanation">
    <div class="body">
      <h3>
        {{ $t('title') }}
      </h3>
      <p class="text">
        {{ injectSnippets($t('text')) }}
      </p>
      <Btn @click="scrollToForm">
        {{ $t('cta') }}
      </Btn>
    </div>
  </div>
</template>

<script>
import { getters } from 'views/utils'
import { scrollToHash } from '../../../../router/smoothScroll'

export default {
  computed: getters('injectSnippets'),
  methods: {
    scrollToForm() {
      scrollToHash('#form')
    },
  },
}
</script>

<style lang="scss">
.SectionExplanation {
  // background-color: $grey-lighter;
  margin: 2rem 0;
  .body {
    padding: 2rem 0;
    .text {
      margin: 1rem 0;
    }
    .Btn {
      margin-top: 1rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "cta": "Get offer",
    "text": "Sun Investment Group has completed over {constructedMw} MW of solar power plants in Europe. These power plants are based on the land, rented from farmers, entrepreneurs and local government units. With the success rate of 98% PV plants completed, the company guarantees fruitful cooperation and secure income for the agreed period.",
    "title": "Land lease for guaranteed income"
  },
  "it": {
    "cta": "Richiedi la tua offerta",
    "text": "Sun Investment Group ha sviluppato oltre {constructedMw} MWp di impianti fotovoltaici in Europa. Questi impianti sono stati realizzati su terreni affittati da agricoltori, imprenditori, proprietari terrieri ed enti locali. Con un tasso di successo del 98% di impianti portati ad autorizzazione, il nostro Gruppo può garantire una cooperazione vantaggiosa e di lunga durata.",
    "title": "Affidaci Il tuo terreno per un guadagno certo"
  },
  "lt": {
    "cta": "",
    "text": "",
    "title": ""
  },
  "pl": {
    "cta": "Porozmawiaj z ekspertami SIG",
    "text": "Współpracujemy z właścicielami gruntów, którzy szukają dodatkowego, stabilnego źródła dochodów. Do tej pory z sukcesem zrealizowaliśmy już 109 projektów farm słonecznych na terenie całej Polski. Farmy budowane są na gruntach gorszej klasy (IV-VI) lub nieużytkach, dzierżawionych od właścicieli ziem, to dzięki ich zaufaniu możemy rozwijać kolejne projekty.",
    "title": "Dzierżawa gruntu, to źródło dodatkowego i stabilnego zysku na lata"
  }
}
</i18n>
